"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sidebar = exports.AccordionGroup = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = require("@chakra-ui/react");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Sidebar = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 1rem;\n\n  background-color: ", ";\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 4;\n  transform: translateX(-100%);\n\n  width: 80%;\n  height: 100%;\n  padding: 4rem 1.5rem 1.5rem 1.5rem;\n  transition: ", ";\n\n  @media (min-width: 481px) {\n    width: 20%;\n    max-width: 500px;\n    min-width: 300px;\n  }\n"])), props => props.theme.sidebar.backgroundColor, props => props.theme.sidebar.transition);

exports.Sidebar = Sidebar;
var AccordionGroup = (0, _styledComponents.default)(_react.Accordion)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: .5rem;\n\n  height: 100%;\n  overflow-y: auto;\n  scrollbar-width: thin;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n    background: rgba(0, 0, 0, .3);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, .5);\n    border-radius: 10px;\n  }\n"])));
exports.AccordionGroup = AccordionGroup;